import { App } from "@pimo/pimo-app-builder";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../app";
import { getLocalizedCardCopy } from "../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../utils/get-plural-of-item-name";
import { getProjectName } from "../../utils/get-plural-of-project-name";

/**
 * Mirrors the `getCardCopy` closure `addComponentsToLayout` used to build
 * inline (#2222): `itemName`/`itemNamePlural`/`projectName` are resolved
 * once, from the app's language at the moment the cards are built, and stay
 * fixed inside the returned closure even when a caller later passes a
 * different `currentLanguage`.
 */
export function makeGetCardCopy(app: App<TestAppState>) {
  const state = app.getAppState();
  const language = state.language || "en";
  const { settings } = state;
  const itemName = getItemName(settings?.configuration?.itemName, language);
  const itemNamePlural = getPluralOfItemName(
    settings?.configuration?.itemName,
    language
  );
  const projectName = getProjectName(
    settings?.configuration?.projectName,
    language
  );
  const categoryLabel =
    settings?.configuration?.fieldsDefinition?.find(
      (field) => field.fieldName === "category"
    )?.label ?? getLocalizedMessage(language, "category");

  return (
    currentLanguage: string,
    key: Parameters<typeof getLocalizedCardCopy>[1],
    params: Parameters<typeof getLocalizedCardCopy>[2] = {}
  ) =>
    getLocalizedCardCopy(currentLanguage, key, {
      itemName,
      itemNamePlural,
      projectName,
      categoryLabel,
      ...params,
    });
}
